import { render, staticRenderFns } from "./BiddingStartPrice.vue?vue&type=template&id=729fb350&scoped=true&"
import script from "./BiddingStartPrice.vue?vue&type=script&lang=js&"
export * from "./BiddingStartPrice.vue?vue&type=script&lang=js&"
import style0 from "./BiddingStartPrice.vue?vue&type=style&index=0&id=729fb350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729fb350",
  null
  
)

export default component.exports